// Example 1: Using the DownloadButton component anywhere
import { Tooltip, IconButton } from "@mui/material";
import DownloadImageApi from "../../../../services/downloadImageService"
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

const DownloadFiles = ({
    fileId,
    tooltipText= 'Download',
    fileName='download'
}) => {

     const handleDownload = async (id, fileName) => {
        try {
          const imgRes = await DownloadImageApi.getDownloadedImageul(id);
        const response = await fetch(imgRes?.data || "");
  
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
          const blob = await response.blob();
          const name = fileName?.split('/').pop()
          // Get file extension from URL or filename
          const extension = fileName?.split('.').pop() || response?.data?.split('.').pop()?.split('?')[0] || '';
          const downloadFileName = name || `document.${extension}`;
          
          // Create download link
          const blobUrl = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = blobUrl;
          link.download = downloadFileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
          console.error('Download failed:', error);
        }
      };

  return (
     <Tooltip title={tooltipText}>
                            <span>
                              <IconButton
                                onClick={() => handleDownload(fileId,fileName)}
                              >
                                <CloudDownloadIcon sx={{ color: "#2F5597", fontSize: "20px" }} />
                              </IconButton>
                            </span>
                          </Tooltip>
  );
};
export default DownloadFiles